import React, { FC, useEffect } from 'react'
import { Anchor, Box, Button, Flex, Grid, Text } from 'components/primitives'
import { useENSResolver, useMounted } from '../../hooks'
import Image from 'next/image'
import { Owner } from 'types/OwnersData'

type Props = {
  key: number
  owner: Owner
}

export const OwnerDetail: FC<Props> = ({ key, owner }) => {
  const {
    avatar: ensAvatar,
    name: name,
    shortAddress,
  } = useENSResolver(owner.address)

  return (
    <>
      <Anchor
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Flex
          css={{
            gap: 20,
            alignItems: 'center',
            padding: '15px 0',
          }}
        >
          <img
            src={ensAvatar ? ensAvatar : '/SteelVault.png'}
            width={40}
            height={40}
            alt="profile avatar"
          />
          <Flex css={{ flexDirection: 'column' }}>
            <Text style="subtitle1">
              {name !== owner.address ? name : 'Unnamed'}
            </Text>
            <Text style="subtitle2">{shortAddress}</Text>
          </Flex>
        </Flex>
        <Text>
          {owner?.ownership?.tokenCount
            ? `${owner?.ownership?.tokenCount} items`
            : '-'}
        </Text>
      </Anchor>
      <Box
        css={{
          backgroundColor: '#1C1C1E',
          height: '0.5px',
          margin: '16px 0',
        }}
      />
    </>
  )
}

export default OwnerDetail
